import { Decimal } from 'decimal.js';
import { CatalogType, DoseCalcModeActive, RoundingMode } from '../../database/schema.js';
/** The drug's dose rounding mode, read from the same details the prescription pop-up reads (getDrugDetails in the app). */
export function getDrugRoundingMode(drug) {
    if (drug?.catalogType === CatalogType.enum.SUPPORTIVE_MEDICATION)
        return drug.supportiveMedicationDetails?.roundingMode;
    return drug?.activeSubstanceDetails?.roundingMode;
}
// The one total-amount calculation: the pop-up, every save and every recalculation use it, so the saved dose is the one shown.
// With a precision, NONE and NEAREST both round half up; without a precision nothing is rounded.
export function getTotalAmountOfSubstanceDecimal(params) {
    const dose = new Decimal(params.dose);
    const proportion = new Decimal(params.doseProportion || 100);
    const base = dose.div(100).mul(proportion);
    let result;
    switch (params.calculationMethod) {
        case DoseCalcModeActive.enum.BSA:
            if (!params.bsa)
                return 0;
            result = base.mul(params.bsa);
            break;
        case DoseCalcModeActive.enum.BSA30:
            if (!params.weight)
                return 0;
            result = base.mul(new Decimal(params.weight).mul('0.0333'));
            break;
        case DoseCalcModeActive.enum.WEIGHT:
            if (!params.weight)
                return 0;
            result = base.mul(params.weight);
            break;
        case DoseCalcModeActive.enum.AUC:
            if (!params.gfr)
                return 0;
            result = base.mul(new Decimal(params.gfr).plus(25));
            break;
        default:
            result = base;
            break;
    }
    if (params.dosePrecision !== undefined && params.dosePrecision !== null) {
        const rounding = toDecimalRoundingMode(params.roundingMode);
        if (rounding !== undefined) {
            result = result.toDecimalPlaces(params.dosePrecision, rounding);
        }
        else {
            result = result.toDecimalPlaces(params.dosePrecision);
        }
    }
    return result.toNumber();
}
function toDecimalRoundingMode(mode) {
    switch (mode) {
        case 'UP':
            return Decimal.ROUND_UP;
        case 'DOWN':
            return Decimal.ROUND_DOWN;
        case 'NEAREST':
            return Decimal.ROUND_HALF_UP;
        default:
            return undefined;
    }
}
//# sourceMappingURL=patient-drug-total-amount.js.map